<template>
  <div class="container-fluid">
    <div class="login">
      <div class="card p-sm-5 p-3" style="width: 40rem;">
        <div class="card-body">
          <h5 class="card-title text-center">
            <img style="width: 60%" src="/assets/logo/logo_white.svg" />
          </h5>

          <form action="#" @submit.prevent="submit()" class="mt-5">
            <div class="text-white">
              <p class="text-uppercase">
                Welkom bij MijnVerenigingsWeb
              </p>
            </div>
            <div class="row mt-2">
              <div class="col-12">
                <p v-if="this.error" class="text-danger">
                  {{ this.error }}
                </p>
              </div>
              <div class="col-6">
                <input
                  type="text"
                  name="firstname"
                  class="form-control"
                  v-model="user.firstname"
                  placeholder="Voornaam (required)"
                  @change="validateInput()"
                />
              </div>
              <div class="col-6">
                <input
                  type="text"
                  name="lastname"
                  class="form-control"
                  v-model="user.lastname"
                  placeholder="Achternaam"
                  @change="validateInput()"
                />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-6">
                <input
                  type="text"
                  name="display_name"
                  class="form-control"
                  v-model="user.display_name"
                  placeholder="Weergave naam (required)"
                  @change="validateInput()"
                />
              </div>
              <div class="col-6">
                <input
                  type="email"
                  name="email"
                  class="form-control"
                  v-model="user.email"
                  placeholder="Emailadres (required)"
                  @change="validateInput()"
                />
              </div>
            </div>
            <div class="form-group mt-4 text-white text-center">
              <label class="form-check-label cursor-pointer">
                <input
                  type="checkbox"
                  class="form-check-input"
                  v-model="user.toc"
                  required
                  @change="validateInput()"
                />
                Ik ga akkoord met de algemene voorwaarden van
                <a
                  class="text-white text-underline"
                  href="https://www.mijnverenigingsweb.nl/algemene-voorwaarden"
                  target="_blank"
                >
                  MijnVerenigingsWeb
                </a>
              </label>
            </div>

            <div class="text-center">
              <button
                :disabled="!validInput"
                type="submit"
                class="btn btn-dark mt-4 "
                to="/register-community"
              >
                Next <i class="fa fa-angle-right" style="padding-left: 5px"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <sideArrows v-bind:arrows="arrows"></sideArrows>
      <bottomDots v-bind:step="step"></bottomDots>
    </div>
  </div>
</template>

<script>
import bottomDots from "./bottomDots";
import sideArrows from "./sideArrows";

export default {
  components: { bottomDots, sideArrows },
  data() {
    return {
      validInput: false,
      error: "",
      step: "step1",
      arrows: {
        left: false,
        rightRoute: "#",
        leftRoute: "/",
        right: true,
      },
    };
  },
  computed: {
    user: {
      get() {
        return this.$store.state.register;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    validateInput() {
      const { firstname, lastname, email, display_name, toc } = this.user;

      if (!(firstname && lastname && email && display_name && toc)) {
        this.validInput = false;
        this.arrows.rightRoute = "#";
      } else {
        this.validInput = true;
        this.arrows.rightRoute = "/register-community";
      }
    },

    submit() {
      if (!this.validInput) {
        this.error = "Alle velden zijn verplicht";
        return;
      }

      this.$store.state.register = this.user;
      this.$router.push("/register-community");
    },
  },
  created() {
    this.validateInput();
  },
};
</script>

<style scoped>
.container-fluid {
  height: 100vh;
  background: transparent linear-gradient(270deg, #73afe3 0%, #cfe4f6 100%) 0%
    0% no-repeat padding-box;
  opacity: 1;
}
.text-underline {
  text-decoration: underline;
}
.login {
  display: flex;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 20px;
  opacity: 1;
}

.btn {
  background: #292929 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  padding-left: 3rem;
  padding-right: 3rem;
  font-size: 18px !important;
}

.form-control {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029 !important;
  border-radius: 4px !important;
  height: calc(1.5em + 0.75rem + 8px) !important;
  font-size: 15px !important;
}
</style>
